import { createServerFn } from "@tanstack/react-start";

import type { ScheduledSession } from "@/content/schedule";

export interface ScheduleResult {
  sessions: ScheduledSession[];
  source: "live" | "unavailable";
}

/** Public, read-only list of scheduled sessions from the Scheduler API only. */
export const listScheduledSessions = createServerFn({ method: "GET" }).handler(
  async (): Promise<ScheduleResult> => {
    try {
      const { getScheduledSessions } = await import("@/lib/scheduler.server");
      return { sessions: await getScheduledSessions(), source: "live" };
    } catch (error) {
      console.error("[scheduler] failed to load sessions", error);
      return { sessions: [], source: "unavailable" };
    }
  },
);
